export const SEARCH = 'search'
export const AMOUNT = 'amount'
export const YEARS_TRADING = 'years-trading'
export const TURNOVER = 'turnover'
export const ASSETS = 'assets'
export const PURPOSE = 'purpose'
export const WHEN = 'when'
export const BUSINESS_TYPE = 'business-type'
export const BUSINESS_INPUT = 'business-input'
